import React from 'react';
import { useIntl } from 'react-intl';
import { CenteredFlexBox } from '../../../../../../Components/FlexBox';
import PhoneForwardedOutlinedIcon from '@mui/icons-material/PhoneForwardedOutlined';
import PhoneMissedOutlinedIcon from '@mui/icons-material/PhoneMissedOutlined';
import { Typography, Grid } from '@mui/material';
import capitalize from '../../../../../../Helpers/StringsFormatting/capitalize';
import Chip from '../../../../../../Components/Chip';
import CaptionValue from '../../../../../../Components/CaptionValue/CaptionValue';
import {
  ACTIVITY_TYPES_ICONS,
  ACTIVITY_TYPES_COLORS,
} from '../../../../../../Utils/constants/activityTypes';
import { ICONS } from '../../../../../../Utils/constants/icons';

const CallItem = function CallItem({
  name,
  campaignAdvancement,
  activityTypes,
  extensionData,
}) {
  const intl = useIntl();
  const { answered, sections, nextActType, shouldSync } = {
    answered: extensionData?.Answered || extensionData?.answered,
    sections: extensionData?.Sections || extensionData?.sections,
    nextActType: extensionData?.NextActType || extensionData?.nextActType,
    shouldSync: extensionData?.ShouldSync || extensionData?.shouldSync,
  };

  const icon = answered ? (
    <PhoneForwardedOutlinedIcon color="success" />
  ) : (
    <PhoneMissedOutlinedIcon color="error" />
  );

  const nextActivityType = (activityTypes || []).find(
    ({ id }) => id === nextActType
  )?.name;

  const NextActivityIcon = ACTIVITY_TYPES_ICONS[nextActivityType];
  return (
    <Grid
      container
      spacing={4}
      sx={{
        alignItems: "center",
        width: '100%'
      }}>
      <Grid size={8}>
        <CenteredFlexBox gap="16px">
          {icon}
          <Typography variant="h6">
            {capitalize(intl.messages[name?.toUpperCase()] ?? name)}
          </Typography>
        </CenteredFlexBox>
      </Grid>
      <Grid size={4}>
        <Chip
          id={`${name}-call-percentage`}
          variant="outlined"
          label={`${campaignAdvancement}%`}
          fontSize="1.5rem"
          color="#1D5B9D"
        />
      </Grid>
      {nextActivityType && (
        <>
          <Grid size={8}>
            <CaptionValue
              caption="NEXTACTIVITYTYPE"
              captionColor="primary"
              captionStyle={{ fontWeight: 'bold', textTransform: 'uppercase' }}
              value={
                <CenteredFlexBox gap="8px">
                  {NextActivityIcon && (
                    <NextActivityIcon
                      sx={{
                        color: ACTIVITY_TYPES_COLORS[nextActivityType],
                      }}
                    />
                  )}
                  <Typography variant="body1">
                    {intl.messages[nextActivityType] ?? nextActivityType}
                  </Typography>
                </CenteredFlexBox>
              }
            />
          </Grid>
          <Grid size={4}>
            <CaptionValue
              caption="SHOULDSYNC"
              captionColor="primary"
              captionStyle={{ fontWeight: 'bold', textTransform: 'uppercase' }}
              value={shouldSync ? intl.messages.YES : intl.messages.NO}
            />
          </Grid>
        </>
      )}
      <Grid size={12}>
        <CaptionValue
          caption="SECTIONS"
          captionColor="primary"
          captionStyle={{ fontWeight: 'bold', textTransform: 'uppercase' }}
          value={
            <Grid container spacing={1}>
              {sections?.map((section) => {
                const Icon = ICONS[section?.toUpperCase()];
                return (
                  <Grid key={section} size={4}>
                    <Chip
                      label={intl.messages[section?.toUpperCase()] || section}
                      icon={Icon && <Icon style={{ color: 'inherit' }} />}
                      variant="outlined"
                      width="100%"
                    />
                  </Grid>
                );
              })}
            </Grid>
          }
        />
      </Grid>
    </Grid>
  );
};

export default CallItem;
